import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import AuthenticationService from './AuthenticationService.js'

class SidebarComponent extends Component {

    constructor(props) {
        super(props)
        this.state = { collapsed: false, mobileOpen: false }
        this.toggleCollapse = this.toggleCollapse.bind(this)
        this.toggleMobile = this.toggleMobile.bind(this)
    }

    toggleCollapse() {
        const next = !this.state.collapsed
        this.setState({ collapsed: next })
        if (this.props.onCollapse) this.props.onCollapse(next)
    }

    toggleMobile() {
        this.setState({ mobileOpen: !this.state.mobileOpen })
    }

    render() {
        const isUserLoggedIn = AuthenticationService.isUserLoggedIn()
        if (!isUserLoggedIn) return null

        const userName = AuthenticationService.getLoggedInUserName()
        const { collapsed, mobileOpen } = this.state
        const currentPath = window.location.pathname

        const navItems = [
            { perm: "READ_ALERTAS",         to: "/alertas",          label: "Alertas",          icon: "🔔" },
            { perm: "READ_SOCIEDADES",       to: "/sociedades",       label: "Sociedades",       icon: "🏢" },
            { perm: "READ_CLIENTES",         to: "/clientes",         label: "Proyectos",        icon: "📁" },
            { perm: "READ_DOMICILIOS",       to: "/domicilios",       label: "Domicilios",       icon: "📍" },
            { perm: "READ_DOCUMENTOS",       to: "/documentos",       label: "Documentos",       icon: "📄" },
            { perm: "READ_PERSONAS_FISICAS", to: "/personas-fisicas", label: "Personas Físicas", icon: "👤" },
            { perm: "READ_CFDIS",            to: "/cfdis",            label: "CFDIs",            icon: "🧾" },
            { perm: "READ_HISTORIA",         to: "/historial",        label: "Historial",        icon: "📋" },
            { perm: "READ_BUSQUEDA",         to: "/busqueda",         label: "Búsqueda",         icon: "🔍" },
            { perm: "READ_USUARIOS",         to: "/users",            label: "Usuarios",         icon: "👥" },
        ]

        const W = collapsed ? 64 : 240

        return (
            <>
                <style>{`
                    @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Cinzel:wght@700&display=swap');

                    .bdc-sidebar {
                        width: ${W}px;
                        min-height: 100vh;
                        background: #0f172a;
                        display: flex;
                        flex-direction: column;
                        position: fixed;
                        top: 0; left: 0;
                        z-index: 200;
                        transition: width 0.25s ease;
                        overflow: hidden;
                        font-family: 'Inter', sans-serif;
                    }

                    .bdc-sb-brand {
                        display: flex; align-items: center; gap: 12px;
                        padding: 16px 14px;
                        border-bottom: 1px solid rgba(255,255,255,0.06);
                        text-decoration: none;
                        min-height: 72px;
                        overflow: hidden;
                    }
                    .bdc-sb-icon {
                        width: 44px; height: 44px; border-radius: 10px;
                        background: transparent;
                        display: flex; align-items: center; justify-content: center;
                        flex-shrink: 0;
                        overflow: hidden;
                    }
                    .bdc-sb-skull { width: 100%; height: 100%; object-fit: contain; mix-blend-mode: screen; }
                    .bdc-sb-titles {
                        overflow: hidden; white-space: nowrap;
                        opacity: ${collapsed ? 0 : 1};
                        transition: opacity 0.2s;
                    }
                    .bdc-sb-name {
                        font-size: 0.82rem; font-weight: 700; display: block;
                        letter-spacing: 4px;
                        font-family: 'Cinzel', serif;
                        background: linear-gradient(135deg, #67e8f9 0%, #38bdf8 40%, #818cf8 100%);
                        -webkit-background-clip: text; -webkit-text-fill-color: transparent;
                        background-clip: text;
                        filter: drop-shadow(0 0 6px rgba(56,189,248,0.4));
                    }
                    .bdc-sb-sub { font-size: 0.62rem; color: rgba(255,255,255,0.3); letter-spacing: 2px; text-transform: uppercase; }

                    .bdc-sb-nav {
                        flex: 1; padding: 10px 8px;
                        overflow-y: auto; overflow-x: hidden;
                        scrollbar-width: thin;
                        scrollbar-color: rgba(255,255,255,0.08) transparent;
                    }
                    .bdc-sb-nav::-webkit-scrollbar { width: 3px; }
                    .bdc-sb-nav::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.08); border-radius: 2px; }
                    .bdc-sb-nav ul { list-style: none; margin: 0; padding: 0; }
                    .bdc-sb-nav ul li { margin-bottom: 2px; position: relative; }
                    .bdc-sb-nav ul li a {
                        display: flex; align-items: center; gap: 12px;
                        padding: 10px 12px; border-radius: 10px;
                        text-decoration: none;
                        color: rgba(255,255,255,0.45);
                        font-size: 0.83rem; font-weight: 500;
                        transition: all 0.2s;
                        white-space: nowrap; overflow: hidden;
                        position: relative;
                    }
                    .bdc-sb-nav ul li a:hover { background: rgba(255,255,255,0.05); color: rgba(255,255,255,0.85); }
                    .bdc-sb-nav ul li a.sb-active { background: rgba(59,130,246,0.15); color: #60a5fa; }
                    .bdc-sb-nav ul li a.sb-active::before {
                        content: ''; position: absolute;
                        left: 0; top: 20%; bottom: 20%;
                        width: 3px; border-radius: 2px; background: #3b82f6;
                    }
                    .sb-icon { font-size: 1rem; flex-shrink: 0; }
                    .sb-label {
                        overflow: hidden;
                        opacity: ${collapsed ? 0 : 1};
                        transition: opacity 0.15s;
                        white-space: nowrap;
                    }
                    .sb-tooltip {
                        display: none;
                        position: absolute;
                        left: 52px; top: 50%; transform: translateY(-50%);
                        background: #1e293b; border: 1px solid #334155;
                        color: white; padding: 5px 10px;
                        border-radius: 7px; font-size: 0.78rem;
                        white-space: nowrap; z-index: 999;
                        box-shadow: 0 4px 12px rgba(0,0,0,0.3);
                        pointer-events: none;
                    }
                    ${collapsed ? '.bdc-sb-nav ul li a:hover .sb-tooltip { display: block; }' : ''}

                    .bdc-sb-user {
                        padding: 10px;
                        border-top: 1px solid rgba(255,255,255,0.06);
                        display: flex; align-items: center; gap: 10px;
                        overflow: hidden; min-height: 58px;
                    }
                    .bdc-sb-avatar {
                        width: 32px; height: 32px; border-radius: 9px;
                        background: linear-gradient(135deg, #3b82f6, #1d4ed8);
                        display: flex; align-items: center; justify-content: center;
                        color: white; font-size: 0.75rem; font-weight: 700;
                        text-transform: uppercase; flex-shrink: 0;
                    }
                    .bdc-sb-userinfo {
                        flex: 1; overflow: hidden; white-space: nowrap;
                        opacity: ${collapsed ? 0 : 1};
                        transition: opacity 0.15s;
                    }
                    .bdc-sb-uname { font-size: 0.8rem; font-weight: 600; color: rgba(255,255,255,0.8); display: block; }
                    .bdc-sb-role { font-size: 0.65rem; color: rgba(255,255,255,0.3); }
                    .bdc-sb-logout {
                        width: 28px; height: 28px; border-radius: 7px;
                        background: rgba(239,68,68,0.1); border: 1px solid rgba(239,68,68,0.2);
                        color: #fca5a5; font-size: 0.8rem;
                        display: flex; align-items: center; justify-content: center;
                        text-decoration: none; flex-shrink: 0; cursor: pointer;
                        opacity: ${collapsed ? 0 : 1};
                        pointer-events: ${collapsed ? 'none' : 'auto'};
                        transition: opacity 0.15s, background 0.2s, color 0.2s;
                    }
                    .bdc-sb-logout:hover { background: #ef4444; color: white; border-color: #ef4444; }

                    .bdc-overlay {
                        display: none; position: fixed; inset: 0;
                        background: rgba(0,0,0,0.5); z-index: 150;
                    }
                    .bdc-overlay.open { display: block; }

                    .bdc-mob-bar {
                        display: none;
                        position: fixed; top: 0; left: 0; right: 0; height: 50px;
                        background: #0f172a;
                        align-items: center; padding: 0 16px; gap: 12px;
                        z-index: 100; box-shadow: 0 2px 8px rgba(0,0,0,0.3);
                        font-family: 'Inter', sans-serif;
                    }
                    .bdc-mob-bar-btn { background: none; border: none; color: white; font-size: 1.2rem; cursor: pointer; }
                    .bdc-mob-bar-title { color: white; font-weight: 700; font-size: 0.9rem; letter-spacing: 2px; }

                    @media (max-width: 768px) {
                        .bdc-sidebar { transform: translateX(-100%); width: 240px !important; }
                        .bdc-sidebar.mob-open { transform: translateX(0); }
                        .bdc-collapse-btn { display: none !important; }
                        .bdc-mob-bar { display: flex; }
                        .bdc-sb-titles { opacity: 1 !important; }
                        .bdc-sb-userinfo { opacity: 1 !important; }
                        .bdc-sb-logout { opacity: 1 !important; pointer-events: auto !important; }
                        .sb-label { opacity: 1 !important; }
                    }
                    @keyframes sb-particle {
                        0%   { transform: translateY(100vh); opacity: 0; }
                        10%  { opacity: 1; }
                        90%  { opacity: 1; }
                        100% { transform: translateY(-80px); opacity: 0; }
                    }
                    .sb-particle {
                        position: absolute;
                        border-radius: 50%;
                        background: rgba(59,130,246,0.45);
                        animation: sb-particle linear infinite;
                        pointer-events: none;
                        z-index: 0;
                    }
                    @media print { .bdc-sidebar { display: none; } .bdc-mob-bar { display: none; } .bdc-collapse-btn { display: none !important; } }
                `}</style>

                {/* Mobile overlay */}
                <div className={`bdc-overlay${mobileOpen ? ' open' : ''}`} onClick={this.toggleMobile} />

                {/* Sidebar — sin botón adentro */}
                <aside className={`bdc-sidebar${mobileOpen ? ' mob-open' : ''}`}>

                    {[...Array(10)].map((_, i) => (
                        <div key={i} className="sb-particle" style={{
                            left: `${10 + Math.random() * 80}%`,
                            width: `${1 + Math.random() * 2.5}px`,
                            height: `${1 + Math.random() * 2.5}px`,
                            opacity: 0.15 + Math.random() * 0.3,
                            animationDuration: `${10 + Math.random() * 14}s`,
                            animationDelay: `${Math.random() * 10}s`,
                        }} />
                    ))}
                    <Link to={`/welcome/${userName}`} className="bdc-sb-brand">
                        <div className="bdc-sb-icon">
                            <img
                                src="/pshm6spshm6spshm.png"
                                alt="Cloud Zenyth" className="bdc-sb-skull"
                                onError={(e) => { e.target.style.display='none'; e.target.parentNode.innerHTML='💀' }}
                            />
                        </div>
                        <div className="bdc-sb-titles">
                            <span className="bdc-sb-name">Cloud  Zenyth</span>
                            <span className="bdc-sb-sub">Administración</span>
                        </div>
                    </Link>

                    <nav className="bdc-sb-nav">
                        <ul>
                            {navItems.map(item =>
                                AuthenticationService.haveAuthorization(item.perm) && (
                                    <li key={item.to} onClick={() => this.setState({ mobileOpen: false })}>
                                        <Link
                                            to={item.to}
                                            className={currentPath.startsWith(item.to) ? 'sb-active' : ''}
                                        >
                                            <span className="sb-icon">{item.icon}</span>
                                            <span className="sb-label">{item.label}</span>
                                            <span className="sb-tooltip">{item.label}</span>
                                        </Link>
                                    </li>
                                )
                            )}
                        </ul>
                    </nav>

                    <div className="bdc-sb-user">
                        <div className="bdc-sb-avatar">{userName.charAt(0)}</div>
                        <div className="bdc-sb-userinfo">
                            <span className="bdc-sb-uname">{userName}</span>
                            <span className="bdc-sb-role">Administrador</span>
                        </div>
                        <Link className="bdc-sb-logout" to="/logout" onClick={AuthenticationService.logout} title="Cerrar sesión">✕</Link>
                    </div>
                </aside>

                {/* Botón colapsar — flotante FUERA del aside, se mueve con el ancho */}
                <button
                    className="bdc-collapse-btn"
                    onClick={this.toggleCollapse}
                    style={{
                        position: 'fixed',
                        left: W - 11,
                        top: 22,
                        width: 22, height: 22,
                        borderRadius: '50%',
                        background: '#1e293b',
                        border: '2px solid #334155',
                        color: 'rgba(255,255,255,0.6)',
                        fontSize: '0.75rem',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        cursor: 'pointer',
                        zIndex: 300,
                        transition: 'left 0.25s ease',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
                    }}
                >
                    {collapsed ? '›' : '‹'}
                </button>

                {/* Mobile topbar */}
                <div className="bdc-mob-bar">
                    <button className="bdc-mob-bar-btn" onClick={this.toggleMobile}>☰</button>
                    <span className="bdc-mob-bar-title" style={{ fontFamily: "'Cinzel', serif", letterSpacing: '4px', background: 'linear-gradient(135deg, #67e8f9, #38bdf8, #818cf8)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>Cloud  Zenyth</span>
                </div>
            </>
        )
    }
}

export default SidebarComponent
